module.exports = __webpack_public_path__ + "img/application_button_2.2f5929cf.png";